import r from '~/utils/render-utils';

const PageDigitalVoucherTransactionDetail = () =>
  import(
    /* webpackChunkName: 'digital-voucher-transaction-detail-page' */ '~/pages/NewVirtualProducts/DigitalVoucher/TransactionDetail'
  );
const PagePrepaidPhoneTransactionDetail = () =>
  import(
    /* webpackChunkName: 'prepaid-phone-topup-transaction-detail-page' */ '~/pages/NewVirtualProducts/PrepaidPhoneDetail'
  );
const PageTransactionDetail = () =>
  import(/* webpackChunkName: 'vp-transaction-detail-page' */ '~/pages/NewVirtualProducts/TransactionDetail');
const PagePrepaidPhoneTransaction = () =>
  import(
    /* webpackChunkName: 'prepaid-phone-topup-transaction-page' */ '~/pages/NewVirtualProducts/PrepaidPhoneTransaction'
  );
const PageDigitalSendTransactionDetail = () =>
  import(/* webpackChunkName: 'digital-send-transaction-detail-page' */ '~/pages/NewVirtualProducts/DigitalSendDetail');
const PageEdcCheckBalanceTransactionDetail = () =>
  import(
    /* webpackChunkName: 'edc-check-balance-transaction-detail-page' */ '~/pages/NewVirtualProducts/EdcCheckBalanceDetail'
  );
const PageQrisCashOutTransactionDetail = () =>
  import(
    /* webpackChunkName: 'qris-cash-out-transaction-detail-page' */ '~/pages/NewVirtualProducts/QrisCashOutDetail'
  );
const PageEdcCashOutTransactionDetail = () =>
  import(/* webpackChunkName: 'edc-cash-out-transaction-detail-page' */ '~/pages/NewVirtualProducts/EdcCashOutDetail');
const PageDigitalVoucher = () =>
  import(/* webpackChunkName: 'digital-voucher-index-page' */ '~/pages/NewVirtualProducts/DigitalVoucher/Index');
const PageDigitalVoucherTerms = () =>
  import(/* webpackChunkName: 'digital-voucher-terms-page' */ '~/pages/NewVirtualProducts/DigitalVoucher/Terms');
const PageDigitalVoucherVendorSelection = () =>
  import(
    /* webpackChunkName: 'digital-voucher-vendor-selection-page' */ '~/pages/NewVirtualProducts/DigitalVoucher/VendorSelection'
  );
const PageDigitalVoucherTransact = () =>
  import(
    /* webpackChunkName: 'digital-voucher-transaction-page' */ '~/pages/NewVirtualProducts/DigitalVoucher/Transaction'
  );
const PageDigitalVoucherKyc = () =>
  import(/* webpackChunkName 'digital-voucher-kyc-page' */ '~/pages/NewVirtualProducts/DigitalVoucher/Kyc.vue');

const PageCableTV = () =>
  import(/* webpackChunkName: 'cable-tv-page' */ '~/pages/NewVirtualProducts/CableTV/Index.vue');
const PageCableTVTransact = () =>
  import(/* webpackChunkName: 'cable-tv-transact-page' */ '~/pages/NewVirtualProducts/CableTV/Transaction.vue');
const PageCableTVProductSelection = () =>
  import(
    /* webpackChunkName: 'cable-tv-product-selection-page' */ '~/pages/NewVirtualProducts/CableTV/ProductSelection.vue'
  );
const PageEducationTransaction = () =>
  import(/* webpackChunkName: 'education-transaction-page' */ '~/pages/NewVirtualProducts/Education/Transaction.vue');
const PageEducationProductSelection = () =>
  import(
    /* webpackChunkName: 'education-product-selection-page' */ '~/pages/NewVirtualProducts/Education/ProductSelection.vue'
  );
const PageEducationTransactionDetail = () =>
  import(
    /* webpackChunkName: 'education-transaction-detail-page' */ '~/pages/NewVirtualProducts/Education/TransactionDetail'
  );

const PageTravelAuth = () =>
  import(/* webpackChunkName: 'travel-auth-page' */ '~/pages/NewVirtualProducts/Travel/Auth.vue');

const PageTravelTransaction = () =>
  import(/* webpackChunkName: 'travel-transaction-page' */ '~/pages/NewVirtualProducts/Travel/Transaction.vue');

const routes = [
  {
    path: '/virtual-products/digital-voucher/detail',
    component: r(PageDigitalVoucherTransactionDetail),
    name: 'digital_voucher_trx_detail',
  },
  {
    path: '/virtual-products/prepaid-phone-topup/detail',
    component: r(PagePrepaidPhoneTransactionDetail),
    name: 'prepaid_phone_topup_trx_detail',
  },
  { path: '/virtual-products/detail', component: r(PageTransactionDetail), name: 'vp_trx_detail' },
  {
    path: '/virtual-products/digital-send/detail',
    component: r(PageDigitalSendTransactionDetail),
    name: 'digital-sendtrx_detail',
  },
  {
    path: '/virtual-products/edc-check-balance/detail',
    component: r(PageEdcCheckBalanceTransactionDetail),
    name: 'edc-check-balancetrx_detail',
  },
  {
    path: '/virtual-products/edc-cash-out/detail',
    component: r(PageEdcCashOutTransactionDetail),
    name: 'edc-cash-out-trx_detail',
  },
  {
    path: '/virtual-products/qris-cash-out/detail',
    component: r(PageQrisCashOutTransactionDetail),
    name: 'qris-cash-outtrx_detail',
  },
  {
    path: '/virtual-products/education/detail',
    component: r(PageEducationTransactionDetail),
    name: 'education_detail',
  },

  // mitra-vp-webview
  {
    path: '/buka-20/topup-digital',
    name: 'topup_digital',
    component: r(PageDigitalVoucher),
    children: [
      { path: 'terms', component: r(PageDigitalVoucherTerms), name: 'topup_digital_terms' },
      { path: 'kyc', component: r(PageDigitalVoucherKyc), name: 'topup_digital_kyc' },
      { path: 'vendor', component: r(PageDigitalVoucherVendorSelection), name: 'topup_digital_vendor_selection' },
      {
        path: 'transact/:code',
        component: r(PageDigitalVoucherTransact),
        name: 'topup_digital_transact',
      },
    ],
  },
  {
    path: '/buka-20/prepaid-phone/transact',
    component: r(PagePrepaidPhoneTransaction),
    name: 'prepaid_phone_transact',
  },
  {
    path: '/buka-20/cable-tv',
    name: 'cable_tv',
    component: r(PageCableTV),
  },
  {
    path: '/buka-20/cable-tv/transact',
    name: 'cable_tv_transact',
    component: r(PageCableTVTransact),
  },
  {
    path: '/buka-20/cable-tv/product',
    name: 'cable_tv_product_selection',
    component: r(PageCableTVProductSelection),
  },
  {
    path: '/buka-20/education/transact',
    name: 'education_transact',
    component: r(PageEducationTransaction),
  },
  {
    path: '/buka-20/education/product',
    name: 'education_product_selection',
    component: r(PageEducationProductSelection),
  },
  {
    path: '/buka-20/travel/auth',
    name: 'travel_auth',
    component: r(PageTravelAuth),
  },
  {
    path: '/buka-20/travel/transact',
    name: 'travel_transact',
    component: r(PageTravelTransaction),
  },
];

const vpTrxDetailPath = routes.find(r => r.name === 'vp_trx_detail')?.path;

export { vpTrxDetailPath };
export default routes;
